import { sortedTokensFor, buildRegExp } from '@corp/services/filter'
import { isBlank } from '@corp/helpers/object'
import { isString } from '@corp/helpers/string'

const PUNCTUATION = /[^\p{L}\p{N}]+/u

// Tokens are split on whitespace only, so punctuation typed mid-query stays
// glued to its token ("miami," out of "miami, FL") and can no longer match the
// label it was read off. Each token also contributes its punctuation-free
// pieces, kept longest-first so a token that does match as typed ("macy's")
// still wins over its own fragments.
function highlightTokensFor (query: string) {
  const tokens = sortedTokensFor(query)
    .flatMap(token => [token, ...token.split(PUNCTUATION).filter(part => part.length > 1)])
    .filter(Boolean)

  return [...new Set(tokens)].sort((a, b) => b.length - a.length)
}

// Adds a colored span to the token matches inside the string.
export function highlightString (value: any, { query }: { query: string }) {
  if (isBlank(value)) return []
  if (!isString(value)) value = value.toString()
  const tokens = highlightTokensFor(query)
  let i = 0
  const renderedItems = []
  let queue: any[] = []

  const dequeue = () => {
    if (queue.length) {
      const text = queue.join('')
      renderedItems.push(<span>{text}</span>)
      queue = []
    }
  }

  while (i < value.length) {
    const token = tokens.find(token => buildRegExp(token).test(value.substr(i, token.length)))
    if (token) {
      dequeue()
      const text = value.substr(i, token.length)
      renderedItems.push(<span class="highlighted">{text}</span>)
      i += token.length
    }
    else {
      queue.push(value[i++])
    }
  }
  dequeue()

  return renderedItems
}
